export default class Constantes {
  static snackbarDefaultProps = {
    preventDuplicate: true,
  };
}
